import { type HTMLAttributes } from 'react'
import { cn } from './cn'

type Tone = 'neutral' | 'brand' | 'accent' | 'success' | 'warning' | 'error' | 'info'

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: Tone
  solid?: boolean
}

const softClasses: Record<Tone, string> = {
  neutral: 'bg-surface-elevated text-ink-muted border-line',
  brand:   'bg-brand/10 text-brand border-brand/20',
  accent:  'bg-accent/15 text-accent-deep dark:text-accent-bright border-accent/30',
  success: 'bg-success/10 text-success border-success/20',
  warning: 'bg-warning/10 text-warning border-warning/20',
  error:   'bg-error/10 text-error border-error/20',
  info:    'bg-info/10 text-info border-info/20',
}

const solidClasses: Record<Tone, string> = {
  neutral: 'bg-ink-subtle text-surface',
  brand:   'bg-brand text-white',
  accent:  'bg-accent text-[#0A0A0F]',
  success: 'bg-success text-white',
  warning: 'bg-warning text-[#0A0A0F]',
  error:   'bg-error text-white',
  info:    'bg-info text-white',
}

export function Badge({ tone = 'neutral', solid = false, className, ...rest }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 px-2.5 py-0.5 rounded-pill border text-xs font-medium',
        solid ? `border-transparent ${solidClasses[tone]}` : softClasses[tone],
        className,
      )}
      {...rest}
    />
  )
}
